import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import api from '../api';

const ImpersonationBanner = () => {
  const { user, setToken, setUser } = useAuthStore();
  const navigate = useNavigate();

  // Only show if user is impersonating
  if (!user?.isImpersonation) {
    return null;
  }

  const handleExitImpersonation = async () => {
    try {
      const response = await api.post('/admin/exit-impersonation');
      
      // Restore original admin session
      setToken(response.data.token);
      setUser(response.data.user);
      
      // Redirect back to admin dashboard
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Failed to exit impersonation:', error);
      alert('Failed to exit impersonation. Please try again.');
    }
  };

  return (
    <div className="bg-gradient-to-r from-purple-600 to-purple-700 text-white px-4 py-3 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-purple-500">
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </span>
          </div>
          <div>
            <p className="text-sm font-medium">
              👁️ Impersonation Mode Active
            </p>
            <p className="text-xs opacity-90">
              Viewing as: <span className="font-semibold">{user.email}</span> | 
              Tenant: <span className="font-semibold">{user.tenantId}</span>
            </p>
          </div>
        </div>
        
        <button
          onClick={handleExitImpersonation}
          className="inline-flex items-center px-4 py-2 bg-white text-purple-700 rounded-md hover:bg-purple-50 transition-colors text-sm font-medium shadow-sm"
        >
          <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Exit Impersonation
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;

